import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';
import { OwnershipTypeService } from '../ownership-type.service';
import { IOwnershipTypes } from '../ownership-types';
import { Message } from 'primeng/primeng';
import { Router } from '@angular/router';


@Component({
  selector: 'app-ownership-type-crud',
  templateUrl: './ownership-type-crud.component.html',
  styleUrls: ['./ownership-type-crud.component.css'],
  providers: [OwnershipTypeService],
  encapsulation: ViewEncapsulation.None
})

export class OwnershipTypeCrudComponent implements OnInit {
  
  id: any = null;	
  ownershipTypes: IOwnershipTypes;
  button_caption: string = 'Сохранить';
  button_icon: string = "fa fa-save";
  msgs: Message[] = [];

  constructor(
				private location: Location,
				private router: Router,  
  				private activatedRoute: ActivatedRoute,
  				private ownershipTypeService: OwnershipTypeService
  			 ) { 

  	activatedRoute.params.subscribe(params=>{this.id=params['id']});

  	if(this.id){
	  	this.ownershipTypeService.getOwnershipTypeById(this.id).subscribe(response => this.ownershipTypes=response['data']);
  		this.button_caption="Редактировать";
  		this.button_icon="fa fa-edit";
  	}else{
  	}	

  }

  ngOnInit() {
  	this.ownershipTypes = {id: '', name: '', description: '', available: true};
  }

  backClicked() {
        this.location.back();
  }

  crud(form: NgForm){
  		if(!this.id){
  			this.ownershipTypeService.createOwnershipType(form.value).subscribe(
  				(data) => {this.router.navigate(['dashboard/ownership-type/']);}
  				); 
  		}else{
  			this.ownershipTypeService.updateOwnershipType(form.value,this.id).subscribe(response =>{this.router.navigate(['dashboard/ownership-type/']);});
  		}
  }

}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/ownership_types/ownership-type-crud/ownership-type-crud.component.ts